import { FilterTranslationMap } from '../model';

import './FilterDialogHeader.scss';

export type FilterDialogHeaderProps = {
	numberOfResults: number | undefined;
	translationMap: FilterTranslationMap;
};

const FilterDialogHeader: React.FC<FilterDialogHeaderProps> = ({
	numberOfResults,
	translationMap,
}) => {
	const getMobileTitle = () => {
		if (numberOfResults === 1) {
			return translationMap.titleForMobileSingle;
		} else {
			return translationMap.titleForMobilePlural.replace(
				'{0}',
				`${numberOfResults || ''}`
			);
		}
	};

	return (
		<div className="blk-ac-filter-dialog-header blk-ac-modal-title">
			<h2 className="display-on-mobile">{getMobileTitle()}</h2>
			<h2 className="display-on-desktop">{translationMap.titleForDesktop}</h2>
		</div>
	);
};

export default FilterDialogHeader;
